export const DEFAULT_ACCEPTED_MEDIA_TYPES = [
  // Prefer wildcards for best mobile compatibility (some mobile browsers report empty/odd MIME types)
  "image/*",
  "video/*",
  // Keep explicit types for stricter browsers / nicer picker filtering
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/heic",
  "image/heif",
  // Some pickers filter better with extensions than MIME types
  ".heic",
  ".heif",
  "video/mp4",
  "video/quicktime",
  "video/webm",
  "video/x-m4v",
  "video/3gpp",
  ".hevc",
  ".h265",
];

function getLowercaseExtension(filename: string): string {
  const lastDot = filename.lastIndexOf(".");
  if (lastDot === -1) return "";
  return filename.slice(lastDot + 1).toLowerCase();
}

function isProbablyVideoByExtension(filename: string): boolean {
  const ext = getLowercaseExtension(filename);
  return ["mp4", "mov", "m4v", "webm", "3gp", "3gpp", "mkv", "hevc", "h265"].includes(ext);
}

function isProbablyImageByExtension(filename: string): boolean {
  const ext = getLowercaseExtension(filename);
  return ["jpg", "jpeg", "png", "gif", "webp", "heic", "heif"].includes(ext);
}

export function isAcceptedMediaFile(file: File, acceptedTypes: string[] = DEFAULT_ACCEPTED_MEDIA_TYPES): boolean {
  if (!acceptedTypes || acceptedTypes.length === 0) return true;

  const type = (file.type || "").toLowerCase();
  const name = file.name || "";
  const isTypeUnreliable = !type || type === "application/octet-stream";

  return acceptedTypes.some((rule) => {
    const normalizedRule = (rule || "").toLowerCase().trim();
    if (!normalizedRule) return false;

    if (normalizedRule.startsWith(".")) {
      return name.toLowerCase().endsWith(normalizedRule);
    }

    if (normalizedRule.endsWith("/*")) {
      const prefix = normalizedRule.slice(0, normalizedRule.length - 1);
      if (type && type.startsWith(prefix)) return true;
      if (isTypeUnreliable && prefix === "video/") return isProbablyVideoByExtension(name);
      if (isTypeUnreliable && prefix === "image/") return isProbablyImageByExtension(name);
      return false;
    }

    if (type && type === normalizedRule) return true;

    if (isTypeUnreliable) {
      if (normalizedRule.startsWith("video/")) return isProbablyVideoByExtension(name);
      if (normalizedRule.startsWith("image/")) return isProbablyImageByExtension(name);
    }

    return false;
  });
}

